import { Box, Container, Stack, Typography, useMediaQuery, useTheme } from '@mui/material';
import { AlertBanner, ResursLogo } from '@resurs-internal/mui';
import { ReactElement } from 'react';

import useSetBannerType from '../../hooks/useSetBannerType';
import { StatusPageStyles } from './StatusPage.styles';

type Props = {
    icon: ReactElement;
    title: string;
    body?: string;
    alertTitle?: string;
    alertSubtitle?: string;
    alertSeverity?: 'error' | 'info' | 'success' | 'warning';
    footer?: string | undefined;
    button?: ReactElement;
};

const StatusPage = ({ icon, title, body, alertTitle, alertSubtitle, alertSeverity, footer, button }: Props) => {
    useSetBannerType('none');
    const theme = useTheme();
    const greaterThanMid = useMediaQuery(theme.breakpoints.up('md'));

    return (
        <Container sx={StatusPageStyles}>
            {!greaterThanMid && <ResursLogo aria-label="Resurs Bank" variant="text" width={'128px'} />}
            <Box justifyContent="center" marginBottom={2} marginTop={2}>
                <Stack justifyContent={'flex-end'} alignItems={'center'} spacing={4}>
                    {icon}
                    <Typography variant={'h6'} noWrap height={48}>
                        {title}
                    </Typography>
                </Stack>
                <Stack justifyContent={'flex-end'} alignItems={'center'} spacing={2}>
                    {body && (
                        <Typography variant={'body1'}>
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: body,
                                }}
                            />
                        </Typography>
                    )}
                    {alertTitle && <AlertBanner title={alertTitle} subtitle={alertSubtitle} severity={alertSeverity} />}
                    {footer && (
                        <Typography variant={'caption'} paddingTop={2}>
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: footer,
                                }}
                            />
                        </Typography>
                    )}
                </Stack>
                {button && (
                    <Stack justifyContent={'flex-end'} alignItems={'center'} spacing={2} style={{ marginTop: '32px' }}>
                        {button}
                    </Stack>
                )}
            </Box>
        </Container>
    );
};

export default StatusPage;
